import { useTranslation } from "react-i18next";

import type { Namespace, TFunction } from "i18next";
import type { FallbackNs } from "react-i18next";

/**
 * @example how to use
 * const x:ITranslatableString<"common">=(t)=>t("IRole.super_admin")
 * or
 * const x:ITranslatableString="any string"
 */
export type ITranslatableString<T extends Namespace = "common"> =
  string | ((t: TFunction<FallbackNs<T>>) => string);

/**
 * @example how to use
 * const x:ITranslatableString<"common">=(t)=>t("IRole.super_admin")
 * or
 * const x:ITranslatableString="any string"
 * @param key
 * @returns
 */
export const useParseTranslationString = <T extends Namespace = "common">(
  key: T,
) => {
  const { t } = useTranslation(key);

  const parseTranslatableString = (
    text: ITranslatableString<T> | undefined,
  ) => {
    if (!text) return;
    return typeof text === "string" ? text : text(t);
  };

  return { parseTranslatableString };
};
